/**
 * Edge + vue-router 4.6：visibilitychange 里 replaceState 会把已最小化的窗口重新激活。
 * 对齐 vue-router 5.3：只拦住「页面已隐藏」那一瞬的 replaceState，pagehide / 可见时照常。
 * 必须在 createRouter（vue-router 已注册 visibilitychange）之后调用。
 */
export function installHiddenReplaceStateGuard() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.__zgHiddenReplaceStateGuarded) return
  window.__zgHiddenReplaceStateGuarded = true

  const original = history.replaceState.bind(history)
  let block = false

  document.addEventListener('visibilitychange', () => {
    block = document.visibilityState === 'hidden'
  }, true)

  history.replaceState = function patchedReplaceState() {
    if (block) return
    return original.apply(this, arguments)
  }

  document.addEventListener('visibilitychange', () => {
    block = false
  })
}
